/**
 * True when the top of the element, plus the given amount below it, is on screen.
 */
export function isElementTopInView(element, visibleHeightPx = 200) {
  const { top } = element.getBoundingClientRect();
  return top >= 0 && top + visibleHeightPx <= window.innerHeight;
}

/**
 * Brings a tile into view: scrolls its sideways-scrolling container so the tile is centred,
 * and scrolls the page only if the tile is off screen. visibleTopPx is how much of the top of
 * the screen is covered (by sticky bars), so the tile doesn't end up hidden underneath.
 */
export function scrollTileIntoView(tile, scrollContainer, visibleTopPx = 0) {
  if (!tile) return;
  if (scrollContainer && scrollContainer.scrollWidth > scrollContainer.clientWidth) {
    const tileRect = tile.getBoundingClientRect();
    const containerRect = scrollContainer.getBoundingClientRect();
    const tileLeftInContainer = tileRect.left - containerRect.left + scrollContainer.scrollLeft;
    const left = tileLeftInContainer - scrollContainer.clientWidth / 2 + tileRect.width / 2;
    scrollContainer.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
  }
  // Scroll the page by hand (not scrollIntoView) so it doesn't fight the sideways scroll above.
  const { top, bottom, height } = tile.getBoundingClientRect();
  if (top < visibleTopPx || bottom > window.innerHeight) {
    const targetTop = visibleTopPx + (window.innerHeight - visibleTopPx) / 3;
    window.scrollBy({ top: top - targetTop + height / 2, behavior: 'smooth' });
  }
}

export function scrollToElementIfHidden(element) {
  if (element && !isElementTopInView(element)) {
    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
